import { render, staticRenderFns } from "./watchlist.vue?vue&type=template&id=74e6485e&"
import script from "./watchlist.vue?vue&type=script&lang=js&"
export * from "./watchlist.vue?vue&type=script&lang=js&"
import style0 from "./watchlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports